module.exports = __webpack_public_path__ + "static/blu-metric-logo-f554e6c7a99dabfd268ab75523745dca.jpeg";